import { RequestState } from './Store';

export interface Customer {
  isAuthenticated: boolean;
  knownToken?: string;
  info?: CustomerInfo;
}

export interface CustomerInfo {
  cNumber?: string;
  apcn?: string;
  email?: string;
  emailVerified?: boolean;
  firstName?: string;
  surname?: string;
}

export interface CustomerState extends RequestState {
  data: Customer | null | undefined;
}

export enum CustomerAuthLevel {
  ANONYMOUS = 0,
  KNOWN = 3,
  AUTHENTICATED = 10,
}

export const anonCustomer: Customer = {
  isAuthenticated: false,
};
